import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { AsyncProduct } from './async-product';
import CheckProductPermissions from './check-product-permissions';
import { useDialogExpansionContext } from '../../dialog-expansion-context';
import { AsyncProvider } from './result-provider';

/**
 * A product within the Search Dialog. Each product responds to one tab inside the dialog and its children
 * are conditionally rendered based off whether this product is active
 *
 * The product component does the following
 * Permissions checking, to see if this product can be shown to the user
 * Product registration with the product router
 * Makes a result provider context available to its children
 * Conditionally rendering children if the product is active in the dialog
 * Async loading the component children using React.suspense
 */

export var SearchDialogProduct = function SearchDialogProduct(props) {
  var _useDialogExpansionCo = useDialogExpansionContext(),
    isExpanded = _useDialogExpansionCo.isExpanded;
  return /*#__PURE__*/React.createElement(CheckProductPermissions, props, /*#__PURE__*/React.createElement(AsyncProduct, _extends({}, props, {
    fallback: !isExpanded ? function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null);
    } : undefined
  }), /*#__PURE__*/React.createElement(AsyncProvider, props)));
};